export function bindChannelChunking(channel, event, callback) {
  var events = {};
  channel.bind(event, function (data) {
    if (!Object.prototype.hasOwnProperty.call(events, data.id)) {
      events[data.id] = {
        chunks: [],
        lastIndex: data.lastIndex
      };
    }
    var ev = events[data.id];
    ev.chunks.push({
      chunkData: data.chunk,
      index: data.index
    });
    if (events[data.id].chunks.length === data.lastIndex + 1) {
      var sortedChunks = ev.chunks.sort(function (a, b) {
        return a.index <= b.index ? -1 : 1;
      }).map(function (chunk) {
        return chunk.chunkData;
      });
      callback(JSON.parse(decodeURIComponent(sortedChunks.join(''))));
      delete events[data.id];
    }
  });
}